import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { AbstractMentionResource, UserType as MentionUserType, UserAccessLevel } from '@atlaskit/mention';
import { EntityType } from '../../types';
import { Actions, defaultAttributes, getUsersForAnalytics, SMART_EVENT_TYPE } from '../analytics';
import { DefaultMentionNameResolver } from '../default-mention-name-resolver';
import getUserRecommendations from '../recommendation-client';
var CONTEXT_TYPE = 'Mentions';
var isSmartMentionConfigWithMentionNameResolver = function isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) {
  return !!smartMentionConfig.mentionNameResolver;
};
/*
 * This is a provider implementation which calls URS to provide a list of recommended users/teams to mention.
 * The entryPoint hierarchy is : Editor -> editor-core -> plugins -> mentions -> typeAhead -> getItems -> pluginState.pluginProvider.filter
 * The results are then mapped to mentionItems which have a render prop mentionToTypeaheadItem -> MentionItem
 * https://bitbucket.org/atlassian/atlassian-frontend/src/0884032d85f11f43c13532cd21f13f696b0d28a7/packages/editor/editor-core/src/plugins/mentions/index.tsx#lines-219
 *
 */
var SmartMentionResource = /*#__PURE__*/function (_AbstractMentionResou) {
  _inherits(SmartMentionResource, _AbstractMentionResou);
  var _super = _createSuper(SmartMentionResource);
  function SmartMentionResource(smartMentionConfig) {
    var _this;
    _classCallCheck(this, SmartMentionResource);
    _this = _super.call(this);

    // If the product doesn't provide a mention name resolve, use the default resolver so that
    // mention names can be looked up from PRS without configuration.
    _this.smartMentionConfig = isSmartMentionConfigWithMentionNameResolver(smartMentionConfig) ? smartMentionConfig : _objectSpread(_objectSpread({}, smartMentionConfig), {}, {
      mentionNameResolver: new DefaultMentionNameResolver(smartMentionConfig.baseUrl)
    });
    _this.lastReturnedSearch = 0;
    return _this;
  }
  _createClass(SmartMentionResource, [{
    key: "shouldHighlightMention",
    value: function shouldHighlightMention(mention) {
      if (this.smartMentionConfig.shouldHighlightMention) {
        return this.smartMentionConfig.shouldHighlightMention(mention);
      }
      return false;
    }
  }, {
    key: "notify",
    value: function notify(searchTime, mentionResult, query) {
      if (searchTime > this.lastReturnedSearch) {
        this.lastReturnedSearch = searchTime;
        this._notifyListeners(mentionResult, {
          duration: Date.now() - searchTime
        });
      }
      this._notifyAllResultsListeners(mentionResult);
    }
  }, {
    key: "notifyError",
    value: function notifyError(error, query) {
      this._notifyErrorListeners(error, query);
    }
  }, {
    key: "filter",
    value: function () {
      var _filter = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query, contextIdentifier) {
        var searchTime, results;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.contextIdentifier = contextIdentifier;
              searchTime = Date.now();
              _context.prev = 2;
              _context.next = 5;
              return this.getRecommendedMentions(query ? query : '', contextIdentifier);
            case 5:
              results = _context.sent;
              this.notify(searchTime, results, query);
              _context.next = 12;
              break;
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              this.notifyError(_context.t0, query);
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[2, 9]]);
      }));
      function filter(_x, _x2) {
        return _filter.apply(this, arguments);
      }
      return filter;
    }()
  }, {
    key: "getRecommendedMentions",
    value: function () {
      var _getRecommendedMentions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(query, contextIdentifier) {
        var startTime, conf, maxNumberOfResults, request, users, elapsedTimeMilli, usersForAnalytics, mentions, _elapsedTimeMilli;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              startTime = window.performance.now();
              conf = this.smartMentionConfig;
              maxNumberOfResults = conf.maxNumberOfResults || 100;
              request = {
                baseUrl: conf.baseUrl,
                context: {
                  productKey: conf.productKey,
                  contextType: CONTEXT_TYPE,
                  principalId: conf.principalId || 'context',
                  containerId: contextIdentifier && contextIdentifier.containerId,
                  siteId: conf.siteId,
                  organizationId: conf.orgId,
                  objectId: contextIdentifier && contextIdentifier.objectId || 'undefined',
                  childObjectId: contextIdentifier && contextIdentifier.childObjectId || 'undefined',
                  mentionsSessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined',
                  sessionId: contextIdentifier && contextIdentifier.sessionId || 'undefined'
                },
                includeGroups: conf.includeGroups,
                includeTeams: conf.includeTeams,
                includeUsers: typeof conf.includeUsers === 'undefined' ? true : conf.includeUsers,
                maxNumberOfResults: maxNumberOfResults,
                searchQueryFilter: conf.searchQueryFilter,
                query: query
              };
              _context2.prev = 4;
              this._notifyAnalyticsListeners(SMART_EVENT_TYPE, 'users', Actions.REQUESTED, defaultAttributes(contextIdentifier));
              _context2.next = 8;
              return getUserRecommendations(request);
            case 8:
              users = _context2.sent;
              elapsedTimeMilli = window.performance.now() - startTime;
              usersForAnalytics = getUsersForAnalytics(users);
              this._notifyAnalyticsListeners(SMART_EVENT_TYPE, 'usersRequest', Actions.SUCCESSFUL, _objectSpread({
                elapsedTimeMilli: elapsedTimeMilli,
                users: usersForAnalytics,
                displayedUsers: usersForAnalytics
              }, defaultAttributes(contextIdentifier)));
              mentions = this.transformUsersToMentions(users);
              return _context2.abrupt("return", {
                mentions: mentions,
                query: query
              });
            case 16:
              _context2.prev = 16;
              _context2.t0 = _context2["catch"](4);
              _elapsedTimeMilli = window.performance.now() - startTime;
              this._notifyAnalyticsListeners(SMART_EVENT_TYPE, 'usersRequest', Actions.FAILED, _objectSpread({
                elapsedTimeMilli: _elapsedTimeMilli
              }, defaultAttributes(contextIdentifier)));
              throw _context2.t0 instanceof Error ? _context2.t0 : new Error(String(_context2.t0));
            case 21:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[4, 16]]);
      }));
      function getRecommendedMentions(_x3, _x4) {
        return _getRecommendedMentions.apply(this, arguments);
      }
      return getRecommendedMentions;
    }()
  }, {
    key: "transformTeamMember",
    value: function transformTeamMember(member) {
      return {
        id: member.id,
        name: member.name
      };
    }
  }, {
    key: "transformUserToMention",
    value: function transformUserToMention(item) {
      var type = item.entityType;
      var defaultVals = {
        source: 'smarts'
      };
      if (type === EntityType.USER) {
        var user = item;
        return _objectSpread(_objectSpread({}, defaultVals), {}, {
          id: user.id,
          accessLevel: user.accessLevel,
          avatarUrl: user.avatarUrl,
          mentionName: user.nickname || '',
          name: user.name,
          userType: user.userType
        });
      }
      if (type === EntityType.TEAM) {
        var team = item;
        var teamLink = '';
        var defaultTeamLink = "".concat(window.location.origin, "/people/team/").concat(team.id);
        if (typeof this.smartMentionConfig.teamLinkResolver === 'function') {
          teamLink = this.smartMentionConfig.teamLinkResolver(item.id);
        }
        return _objectSpread(_objectSpread({}, defaultVals), {}, {
          id: team.id,
          name: team.displayName || '',
          mentionName: team.displayName,
          avatarUrl: team.smallAvatarImageUrl,
          accessLevel: UserAccessLevel[UserAccessLevel.CONTAINER],
          userType: MentionUserType[MentionUserType.TEAM],
          lozenge: MentionUserType[MentionUserType.TEAM],
          context: {
            members: team.members ? team.members.map(this.transformTeamMember) : [],
            includesYou: team.includesYou || false,
            memberCount: team.memberCount || 0,
            teamLink: teamLink || defaultTeamLink //OOH HERE Do we pass in resolver or add in provider?
          },
          source: 'smarts'
        });
      }
      if (type === EntityType.GROUP) {
        var group = item;
        return _objectSpread(_objectSpread({}, defaultVals), {}, {
          id: group.id,
          userType: type.toLowerCase(),
          name: group.name || '',
          lozenge: type.toLowerCase()
        });
      }
      return {
        id: item.id,
        userType: EntityType.USER.toLowerCase(),
        avatarUrl: item.avatarUrl,
        name: item.name,
        lozenge: EntityType.USER.toLowerCase()
      };
    }
  }, {
    key: "transformUsersToMentions",
    value: function transformUsersToMentions(recommendationItems) {
      return (recommendationItems || []).map(this.transformUserToMention, this).filter(function (user) {
        return !!user;
      }).map(function (user) {
        return user;
      });
    }
  }, {
    key: "cacheMentionName",
    value: function cacheMentionName(id, mentionName) {
      this.smartMentionConfig.mentionNameResolver.cacheName(id, mentionName);
    }
  }, {
    key: "resolveMentionName",
    value: function resolveMentionName(id) {
      return this.smartMentionConfig.mentionNameResolver.lookupName(id);
    }
  }, {
    key: "supportsMentionNameResolving",
    value: function supportsMentionNameResolving() {
      return true;
    }
  }, {
    key: "recordMentionSelection",
    value: function recordMentionSelection(_mention) {
      this._notifyAnalyticsListeners(SMART_EVENT_TYPE, 'usersRequest', Actions.SELECTED, _objectSpread({
        selectedOption: _mention.id
      }, defaultAttributes(this.contextIdentifier)));
    }
  }]);
  return SmartMentionResource;
}(AbstractMentionResource);
export default SmartMentionResource;